import {Component, Inject} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSelectModule} from '@angular/material/select';
import {MatCheckboxModule} from '@angular/material/checkbox';

export interface PdfExportOptions {
  viewMode: 'perDay' | 'perField';
  paperSize: 'A4' | 'LETTER';
  includeBranding: boolean;
  includeHeaders: boolean;
  includePageNumbers: boolean;
  includeScheduleName: boolean;
  includeVersion: boolean;
}

@Component({
  selector: 'app-export-pdf-dialog',
  templateUrl: './export-pdf-dialog.component.html',
  styleUrls: ['./export-pdf-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatSelectModule,
    MatCheckboxModule,
  ],
})
export class ExportPdfDialogComponent {
  options: PdfExportOptions = {
    viewMode: 'perDay',
    paperSize: 'A4',
    includeBranding: true,
    includeHeaders: true,
    includePageNumbers: false,
    includeScheduleName: true,
    includeVersion: false,
  };

  constructor(
    public dialogRef: MatDialogRef<ExportPdfDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { scheduleName: string }
  ) {}

  onCancel(): void {
    this.dialogRef.close();
  }

  onExport(): void {
    this.dialogRef.close(this.options);
  }
}
